// The operator org list's billing-filter vocabulary (#5726) — one closed list that
// `listAccountsAdmin` (`@developerz/db`), `GET /v1/admin/accounts?filter=billing:<v>`,
// the MCP `orgs_list` action's `billing` field and the dashboard's overview links
// all name, so a value one door accepts is a value every door understands.
//
//   - `paying` — `accounts.seats > 0` or `accounts.purchased_ci_slots > 0` (both
//     Stripe-written; CI slots alone are a purchase).
//   - `comped` — a LIVE `ai_devs` grant lifts the account: one issued to the account
//     itself, or one issued to an owner of a personal (`kind = 'user'`) account
//     (`liftingAiDevsSql` in `@developerz/db` `queries/grants.ts`, on the entitlement
//     liveness predicate `activeGrantsWhere`).
//   - `paused` — `accounts.billing_paused_at` is set.
export const ADMIN_BILLING_FILTERS = ['paying', 'comped', 'paused'] as const;
export type AdminBillingFilter = (typeof ADMIN_BILLING_FILTERS)[number];
